import { useState } from "react";
import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  Grid,
  Radio,
  Avatar,
  IconButton,
  MenuItem,
  Popover,
  Box,
  CircularProgress,
  Chip,
  Stack,
} from "@mui/material";
import { orange, brown, cyan, deepPurple } from "@mui/material/colors";
import Iconify from "../iconify/Iconify";
import PutOnSaleDialog from "./PutOnSaleDialog";
import BuyCardDialog from "./BuyCardDialog";
import AddTrainingDialog from "./AddTrainingDialog";
import { useNavigate } from "react-router-dom";
import { getPositionLetter } from "../../utils/positionUtils";
import { del, post } from "src/utils/networkUtils";
import { getUserPermissions } from "src/utils/permissionsUtils";
import PlayerHeadshot from "../PlayerHeadshot";
import { PlayerStatTypes } from "src/constants/playerStatTypes";

const getTrainingLevel = (count) => {
  if (count >= 10 && count <= 15) return "gold";
  if (count >= 5 && count < 10) return "silver";
  if (count > 0 && count < 5) return "bronze";
  return "none";
};

const getTrainingColor = (level) => {
  switch (level) {
    case "gold":
      return { bgcolor: "#FFD700", color: "#000" };
    case "silver":
      return { bgcolor: "#C0C0C0", color: "#000" };
    case "bronze":
      return { bgcolor: "#CD7F32", color: "#fff" };
    default:
      return { bgcolor: "#e0e0e0", color: "#000" };
  }
};

export default function CardsTable(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(null);
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [cardId, setCardId] = useState(null);
  const [openPutOnSaleDialog, setOpenPutOnSaleDialog] = useState(false);
  const [openBuyDialog, setOpenBuyDialog] = useState(false);
  const [openAddTrainingDialog, setOpenAddTrainingDialog] = useState(false);
  const [binningCardId, setBinningCardId] = useState(null);
  const { isViewer } = getUserPermissions();

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };
  const handleClosePutOnSaleDialog = () => {
    setCardId(null);
    setOpenPutOnSaleDialog(false);
    setOpenBuyDialog(false);
  };
  const handleOpenPutOnSaleDialog = (cardId) => {
    setCardId(cardId);
    setOpenPutOnSaleDialog(true);
  };
  const handleOpenBuyDialog = (cardId) => {
    setCardId(cardId);
    setOpenBuyDialog(true);
  };
  const handleOpenAddTrainingDialog = (cardId) => {
    setCardId(cardId);
    setOpenAddTrainingDialog(true);
    handleCloseMenu();
  };
  const handleCloseAddTrainingDialog = () => {
    setCardId(null);
    setOpenAddTrainingDialog(false);
  };
  const handleSuccessPutOnSaleDialog = () => {
    window.location.reload(true);
  };
  const removeFromSaleHandler = (cardId) => {
    setLoading(true);
    setOpen(null);
    setOpenId(null);
    del(`/admin/marketplace/cards/${cardId}`).then(function (response) {
      window.location.reload(true);
    });
  };
  const binCardHandler = (cardId) => {
    setBinningCardId(Number(cardId));
    setOpen(null);
    setOpenId(null);
    post(`/admin/users/${props.userId}/bin-card/${cardId}`).then(function (
      response
    ) {
      setBinningCardId(null);
      if (props.refreshCards) {
        props.refreshCards();
      }
    });
  };
  return (
    <>
      {loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center" }}
          style={{ padding: "100px 200px" }}
        >
          <CircularProgress />
        </Box>
      ) : null}
      {!loading && (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Rating</TableCell>
                <TableCell>Avatar</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Position</TableCell>
                <TableCell>Team</TableCell>
                <TableCell>Training</TableCell>
                <TableCell>On Sale</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props?.cards?.map((row, index) => {
                const isLast = index === props.cards.length - 1;
                return (
                  <TableRow
                    key={index}
                    ref={isLast ? props.lastCardRef : null}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      position: "relative",
                      opacity: binningCardId === row.cardId ? 0.4 : 1,
                      pointerEvents: binningCardId === row.cardId ? "none" : "auto",
                    }}
                  >
                    {binningCardId === row.cardId && (
                      <TableCell
                        colSpan={9}
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "none",
                          p: 0,
                        }}
                      >
                        <CircularProgress size={24} />
                      </TableCell>
                    )}
                    <TableCell component="th" scope="row">
                      {row.cardId}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.cardRating === 2 && (
                        <Radio
                          checked={true}
                          value={2}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "B" }}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 28,
                            },
                            color: orange[800],
                            "&.Mui-checked": {
                              color: orange[600],
                            },
                          }}
                        />
                      )}

                      {row.cardRating === 1 && (
                        <Radio
                          checked={true}
                          value={1}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "B" }}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 28,
                            },
                            color: cyan[800],
                            "&.Mui-checked": {
                              color: cyan[600],
                            },
                          }}
                        />
                      )}
                      {row.cardRating === 0 && (
                        <Radio
                          checked={true}
                          value={0}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "B" }}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 28,
                            },
                            color: brown[800],
                            "&.Mui-checked": {
                              color: brown[600],
                            },
                          }}
                        />
                      )}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <PlayerHeadshot row={row} />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.knownname}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Avatar sx={{ bgcolor: deepPurple[500] }}>
                        {getPositionLetter(row.position)}
                      </Avatar>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Grid container>
                        <Grid item xs={12} sx={{ textAlign: "left" }}>
                          {row.team}
                        </Grid>
                      </Grid>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Stack direction="row" spacing={0.5} flexWrap="wrap" gap={0.5}>
                        {row.trainingStats && row.trainingStats.length > 0 ? (
                          row.trainingStats.map((training, idx) => {
                            const level = getTrainingLevel(training.TrainingCount);
                            const statName = PlayerStatTypes[training.StatType] || `Stat${training.StatType}`;
                            return (
                              <Chip
                                key={idx}
                                label={`${statName}: ${training.TrainingCount}`}
                                size="small"
                                sx={{
                                  ...getTrainingColor(level),
                                  fontSize: '0.7rem',
                                  height: '20px',
                                }}
                              />
                            );
                          })
                        ) : (
                          <Chip
                            label="No Training"
                            size="small"
                            sx={{ bgcolor: "#f5f5f5", fontSize: '0.7rem', height: '20px' }}
                          />
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.isTrading ? (
                        <Iconify
                          icon={"eva:checkmark-circle-2-outline"}
                          sx={{ color: "green" }}
                        />
                      ) : (
                        <Iconify
                          icon={"eva:close-circle-outline"}
                          sx={{ color: "red" }}
                        />
                      )}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton
                        size="large"
                        color="inherit"
                        onClick={handleOpenMenu}
                        id={row.cardId}
                      >
                        <Iconify icon={"eva:more-vertical-fill"} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 200,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem
          onClick={() => navigate(`/dashboard/card-details?card_id=${openId}`)}
        >
          <Iconify icon={"eva:info-outline"} sx={{ mr: 2 }} />
          Details
        </MenuItem>
        <MenuItem onClick={() => handleOpenPutOnSaleDialog(openId)}>
          <Iconify icon={"eva:corner-left-up-outline"} sx={{ mr: 2 }} />
          Put on Sale
        </MenuItem>
        <MenuItem onClick={() => removeFromSaleHandler(openId)}>
          <Iconify icon={"eva:corner-right-down-outline"} sx={{ mr: 2 }} />
          Remove From Sale
        </MenuItem>
        <MenuItem onClick={() => handleOpenBuyDialog(openId)}>
          <Iconify icon={"eva:behance-outline"} sx={{ mr: 2 }} />
          Buy Card
        </MenuItem>
        <MenuItem onClick={() => handleOpenAddTrainingDialog(openId)}>
          <Iconify icon={"eva:fitness-outline"} sx={{ mr: 2 }} />
          Add Training
        </MenuItem>
        {!isViewer && (
          <MenuItem onClick={() => binCardHandler(openId)}>
            <Iconify icon={"eva:person-delete-outline"} sx={{ mr: 2 }} />
            Bin Card
          </MenuItem>
        )}
      </Popover>
      <PutOnSaleDialog
        open={openPutOnSaleDialog}
        onSuccessHandler={handleSuccessPutOnSaleDialog}
        onClose={handleClosePutOnSaleDialog}
        setLoading={setLoading}
        cardId={cardId}
        userId={props.userId}
      />

      <BuyCardDialog
        open={openBuyDialog}
        onSuccessHandler={handleSuccessPutOnSaleDialog}
        onClose={handleClosePutOnSaleDialog}
        setLoading={setLoading}
        cardId={cardId}
      />

      <AddTrainingDialog
        open={openAddTrainingDialog}
        onClose={handleCloseAddTrainingDialog}
        cardId={cardId}
        onSuccess={handleSuccessPutOnSaleDialog}
      />
    </>
  );
}
